import { Link } from "react-router-dom";
import { createColumnHelper } from "@tanstack/react-table";
import { Button } from "@/components/ui/button";
import { AxisProgress } from "@/modules/core/components/AxisProgress";
import { DocNumberLink } from "@/modules/core/components/DocNumberLink";
import { FilterPartyName } from "@/modules/core/components/DueBadge";
import {
  togglePartyFilter,
  type PartyFilter,
} from "@/modules/core/list-cell-actions";
import type { DeskTableFeatures } from "@/modules/shell/data-table";
import type { SoListRow } from "@/shared/api/sales";

const columnHelper = createColumnHelper<DeskTableFeatures, SoListRow>();

export type ToDeliverCellActions = {
  partyFilter: PartyFilter | null;
  setPartyFilter: (next: PartyFilter | null) => void;
};

export function toDeliverColumns(
  companySlug: string,
  actions: ToDeliverCellActions,
) {
  return columnHelper.columns([
    columnHelper.accessor("number", {
      id: "number",
      header: "Number",
      size: 120,
      cell: (info) => (
        <DocNumberLink
          to={`/c/${companySlug}/sales/orders/${info.row.original.id}`}
        >
          {info.getValue()}
        </DocNumberLink>
      ),
    }),
    columnHelper.accessor("customerName", {
      id: "customerName",
      header: "Customer",
      size: 180,
      cell: (info) => {
        const row = info.row.original;
        return (
          <FilterPartyName
            name={info.getValue()}
            onClick={() =>
              actions.setPartyFilter(
                togglePartyFilter(actions.partyFilter, {
                  id: row.customerId,
                  name: row.customerName,
                }),
              )
            }
          />
        );
      },
    }),
    columnHelper.display({
      id: "deliverPct",
      header: "Delivered",
      size: 120,
      enableSorting: false,
      meta: { align: "right" },
      cell: ({ row }) => {
        const r = row.original;
        return (
          <AxisProgress
            axis="Delivered"
            format="qty"
            current={r.qtyDelivered}
            max={r.qtyOrdered}
          />
        );
      },
    }),
    columnHelper.display({
      id: "actions",
      header: "",
      size: 96,
      enableSorting: false,
      enableResizing: false,
      cell: ({ row }) => (
        <Button variant="outline" asChild size="sm">
          <Link
            to={`/c/${companySlug}/sales/orders/${row.original.id}`}
            className="no-underline"
          >
            Deliver
          </Link>
        </Button>
      ),
    }),
  ]);
}
